import { render } from "./UsersEdit.vue?vue&type=template&id=5460d3c2"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"

import "./UsersEdit.vue?vue&type=style&index=0&id=5460d3c2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__